import React from 'react';
import { Modal, ModalActions } from '../../ui/Modal/Modal';
import styles from './ConfirmDialog.module.scss';

interface ConfirmDialogProps {
    title: string;
    description?: string;
    confirmLabel?: string;
    isBusy?: boolean;
    onConfirm: () => void;
    onClose: () => void;
}

/** Порт ConfirmModal со старого фронта. Красную рамку даёт tone вашей Modal. */
export function ConfirmDialog({
    title,
    description,
    confirmLabel = 'Удалить',
    isBusy = false,
    onConfirm,
    onClose,
}: ConfirmDialogProps) {
    return (
        <Modal
            open
            tone="danger"
            width={440}
            title={title}
            description={description}
            onClose={onClose}
            footer={
                <ModalActions>
                    <button type="button" className={styles.secondary} onClick={onClose}>
                        Отмена
                    </button>
                    <button type="button" className={styles.danger} disabled={isBusy} onClick={onConfirm}>
                        {isBusy ? 'Удаляем…' : confirmLabel}
                    </button>
                </ModalActions>
            }
        />
    );
}
